import React, { useCallback, useState } from 'react';
import AdminUserForm from './AdminUserForm';
import { adminAPI } from '../../../../api';

const CreateAdminUser = ({ tenant, onCreated, onClose }) => {
  const [errors, setErrors] = useState([]);
  const handleFormSubmit = useCallback(async (data) => {
    const response = await adminAPI.createTenantUserAdmin({
      data,
      slug: tenant.slug,
    });
    if (response.success === false) {
      setErrors(response.errors);
    } else {
      onCreated();
    }
  });

  return (
    <div className="p-8">
      <h3
        className="pb-8 pt-12"
        style={{ fontSize: '30px', fontWeight: '800' }}
      >
        New Admin
      </h3>
      <AdminUserForm
        onSubmitForm={handleFormSubmit}
        onCloseForm={onClose}
        errors={errors}
      />
    </div>
  );
};

export default CreateAdminUser;
